export default __webpack_public_path__ + "static/hero-balance-transfer-offer-02ff319cdfb4fbd5bcf7b065342d9872.webp";